/* ==========================================================================
   PINTAFINA — scripts de la tienda (vanilla, sin librerías)
   ========================================================================== */
(function () {
  'use strict';

  var routes = window.routes || {};
  var money = (window.PF && window.PF.moneyFormat) || '${{amount}}';

  /* ---------- helpers ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function formatMoney(cents) {
    // cents = valor en centavos de Shopify. COP no usa decimales -> dividir /100 y sin decimales.
    var value = Math.round(cents / 100);
    var s = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '$' + s;
  }

  /* ---------- reveals ---------- */
  function initReveals() {
    var els = $$('.pf-reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
    // Red de seguridad: si algo impide que el observador dispare, muestra todo.
    setTimeout(function () {
      els.forEach(function (e) { if (!e.classList.contains('is-in')) e.classList.add('is-in'); });
    }, 2600);
  }

  /* ---------- header sticky ---------- */
  function initHeader() {
    var h = $('.pf-header');
    if (!h) return;
    var onScroll = function () { h.classList.toggle('is-stuck', window.scrollY > 12); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var burger = $('.pf-burger');
    var mnav = $('.pf-mobilenav');
    if (burger && mnav) {
      burger.addEventListener('click', function () { mnav.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
      $$('.pf-mobilenav a, .pf-mobilenav__close').forEach(function (a) {
        a.addEventListener('click', function () { mnav.classList.remove('is-open'); document.body.style.overflow = ''; });
      });
    }
  }

  /* ---------- marquee: fija duración según ancho ---------- */
  function initMarquee() {
    $$('.pf-marquee').forEach(function (m) {
      var track = $('.pf-marquee__track', m);
      if (!track) return;
      var speed = parseFloat(m.getAttribute('data-speed')) || 40; // px/seg
      var w = track.scrollWidth / 2;
      track.style.animationDuration = (w / speed) + 's';
    });
  }

  /* ---------- carruseles con flechas ---------- */
  function initCarousels() {
    $$('[data-carousel]').forEach(function (wrap) {
      var track = $('.pf-carousel', wrap);
      var prev = $('[data-car-prev]', wrap);
      var next = $('[data-car-next]', wrap);
      if (!track) return;
      var step = function () { return Math.min(track.clientWidth * 0.8, 620); };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* ---------- galería producto ---------- */
  function initGallery() {
    var main = $('.pf-gallery__main img');
    if (!main) return;
    $$('.pf-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (full) main.src = full;
        $$('.pf-thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ---------- selector de cantidad genérico ---------- */
  function initQtyInputs() {
    $$('[data-qty]').forEach(function (box) {
      var input = $('input', box);
      var minus = $('[data-qty-minus]', box);
      var plus = $('[data-qty-plus]', box);
      if (!input) return;
      if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    });
  }

  /* ---------- TOAST ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('.pf-toast');
    if (!t) return;
    $('.pf-toast__msg', t).textContent = msg;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  /* ==========================================================================
     CARRITO
     ========================================================================== */
  function getCart() {
    return fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function updateCartCount(count) {
    $$('.pf-cartcount').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-on', count > 0);
    });
  }

  function buildWhatsAppMessage(cart) {
    var lines = [];
    lines.push('¡Hola Pintafina! 👋 Quiero confirmar mi pedido:');
    lines.push('');
    cart.items.forEach(function (it, i) {
      lines.push((i + 1) + '. ' + it.product_title + (it.variant_title && it.variant_title !== 'Default Title' ? ' (' + it.variant_title + ')' : ''));
      lines.push('   Cantidad: ' + it.quantity + '  ·  ' + formatMoney(it.final_line_price));
    });
    lines.push('');
    lines.push('*Total: ' + formatMoney(cart.total_price) + '*');
    lines.push('');
    lines.push('¿Me confirman disponibilidad y el envío, por favor?');
    return lines.join('\n');
  }

  function waNumber() {
    return (window.PF && window.PF.whatsapp ? window.PF.whatsapp : '').replace(/[^0-9]/g, '');
  }
  // Construye el enlace de WhatsApp con el pedido del carrito (para usar como href
  // de un enlace real: así funciona en móvil, donde abrir ventanas tras una
  // operación en segundo plano queda bloqueado).
  function buildWaUrl(cart) {
    var num = waNumber();
    var msg = encodeURIComponent(buildWhatsAppMessage(cart));
    return (num ? 'https://wa.me/' + num : 'https://wa.me/') + '?text=' + msg;
  }

  function renderDrawer(cart) {
    var body = $('.pf-drawer__body');
    var foot = $('.pf-drawer__foot');
    if (!body) return;
    updateCartCount(cart.item_count);
    if (!cart.items.length) {
      body.innerHTML = '<div class="pf-drawer__empty">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/><path d="M2 3h3l2.4 12.3a1 1 0 0 0 1 .7h9.5a1 1 0 0 0 1-.8L21 7H6"/></svg>' +
        '<p>Tu carrito está vacío.</p></div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';
    var html = '';
    cart.items.forEach(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1') : '';
      var vt = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="pf-card__cat">' + it.variant_title + '</div>' : '';
      html += '<div class="pf-li" data-key="' + it.key + '">' +
        '<div class="pf-li__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="pf-li__info">' +
          '<div class="pf-li__title">' + it.product_title + '</div>' + vt +
          '<div class="pf-li__price">' + formatMoney(it.final_line_price) + '</div>' +
          '<div class="pf-li__foot">' +
            '<div class="pf-qty">' +
              '<button data-dec aria-label="Restar">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button data-inc aria-label="Sumar">+</button>' +
            '</div>' +
            '<button class="pf-li__remove" data-remove>Quitar</button>' +
          '</div>' +
        '</div></div>';
    });
    body.innerHTML = html;
    $('.pf-drawer__total b').textContent = formatMoney(cart.total_price);
    // Mantener el enlace de "Confirmar orden por WhatsApp" al día con el carrito.
    var waA = $('.pf-drawer [data-wa-order]');
    if (waA) waA.setAttribute('href', buildWaUrl(cart));
  }

  function changeItem(key, qty) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function openDrawer() {
    var ov = $('.pf-drawer-overlay'), dr = $('.pf-drawer');
    if (!ov || !dr) return;
    getCart().then(renderDrawer);
    ov.classList.add('is-open'); dr.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var ov = $('.pf-drawer-overlay'), dr = $('.pf-drawer');
    if (ov) ov.classList.remove('is-open');
    if (dr) dr.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function initCart() {
    // abrir/cerrar
    $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); }); });
    $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    var ov = $('.pf-drawer-overlay');
    if (ov) ov.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    // delegación en el cuerpo del drawer
    var body = $('.pf-drawer__body');
    if (body) {
      body.addEventListener('click', function (e) {
        var li = e.target.closest('.pf-li'); if (!li) return;
        var key = li.getAttribute('data-key');
        var qtySpan = $('.pf-qty span', li);
        var q = parseInt(qtySpan.textContent, 10) || 1;
        if (e.target.closest('[data-inc]')) changeItem(key, q + 1).then(renderDrawer);
        else if (e.target.closest('[data-dec]')) changeItem(key, Math.max(0, q - 1)).then(renderDrawer);
        else if (e.target.closest('[data-remove]')) changeItem(key, 0).then(renderDrawer);
      });
    }

    // Los botones "Confirmar orden por WhatsApp" son enlaces reales (href) que se
    // mantienen actualizados: el del cajón por renderDrawer() y el de la página de
    // carrito por Liquid. No interceptamos el clic para no romper el móvil.
  }

  /* ---------- añadir al carrito (formularios producto/tarjetas) ---------- */
  function initAddForms() {
    $$('form[data-add-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type=submit]');
        var original = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.innerHTML = 'Añadiendo…'; }
        var data = new FormData(form);
        fetch(routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: data
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
          if (res.status) { toast('No se pudo añadir 🙁'); return; }
          getCart().then(function (cart) {
            updateCartCount(cart.item_count);
            if (form.getAttribute('data-add-form') === 'buy') {
              // "ordenar enseguida" -> abre WhatsApp directo
              openWhatsApp();
            } else {
              renderDrawer(cart);
              openDrawer();
            }
          });
        }).catch(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
          toast('Error de conexión');
        });
      });
    });
  }

  /* ---------- variantes producto ---------- */
  function initVariants() {
    var root = $('[data-product-json]');
    if (!root) return;
    var variants;
    try { variants = JSON.parse($('[data-product-json]').textContent); } catch (e) { return; }
    var selects = $$('[data-opt]');
    if (!selects.length) return;
    var idInput = $('[data-variant-id]');
    var priceEl = $('[data-variant-price]');
    var addBtn = $('[data-add-btn]');

    function currentOptions() { return selects.map(function (s) { return s.value; }); }
    function match() {
      var opts = currentOptions();
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function update() {
      var v = match();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.innerHTML = v.available ? addBtn.getAttribute('data-label') : 'Agotado';
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  }

  /* ---------- HERO rotativo de ofertas ---------- */
  function initHeroRotate() {
    var hero = $('[data-hero]');
    if (!hero) return;
    var dataEl = $('[data-hero-data]', hero);
    if (!dataEl) return;
    var slides;
    try { slides = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!slides || !slides.length) return;
    var imgs = $$('.pf-hero__slide', hero);
    var order = $('[data-hero-order]', hero);
    var price = $('[data-hero-price]', hero);
    var comp = $('[data-hero-compare]', hero);
    var off = $('[data-hero-off]', hero);
    var name = $('[data-hero-name]', hero);
    var view = $('[data-hero-view]', hero);

    var num = (window.PF && window.PF.whatsapp ? window.PF.whatsapp : '').replace(/[^0-9]/g, '');
    function waLink(s) {
      var msg = '¡Hola Pintafina! 👋 Quiero ordenar esta prenda:\n\n*' + s.name + '* — ' + s.price + '\n\n¿Me confirman disponibilidad, talla y el envío?';
      return (num ? 'https://wa.me/' + num : 'https://wa.me/') + '?text=' + encodeURIComponent(msg);
    }

    function apply(k) {
      var s = slides[k]; if (!s) return;
      imgs.forEach(function (im, ix) { im.classList.toggle('is-active', ix === k); });
      if (order) order.setAttribute('href', waLink(s));
      if (price) price.textContent = s.price;
      if (name) name.textContent = s.name;
      if (view) view.setAttribute('href', s.url);
      if (s.hasOffer) {
        if (off) { off.textContent = '-' + s.off + '%'; off.hidden = false; }
        if (comp) { comp.textContent = s.compare; comp.hidden = false; }
      } else {
        if (off) off.hidden = true;
        if (comp) comp.hidden = true;
      }
    }

    // Empezar en una diapositiva al azar para que la portada varíe en cada visita.
    var i = Math.floor(Math.random() * slides.length);
    apply(i);
    if (slides.length > 1) {
      setInterval(function () { i = (i + 1) % slides.length; apply(i); }, 5000);
    }
  }

  /* ---------- aviso de cookies ---------- */
  function initCookie() {
    var box = $('[data-cookie]');
    if (!box) return;
    var KEY = 'pf_cookie_choice';
    var stored;
    try { stored = localStorage.getItem(KEY); } catch (e) { stored = null; }
    if (stored) return; // ya eligió
    box.hidden = false;
    // pequeña espera para animar la entrada
    setTimeout(function () { box.classList.add('is-on'); }, 600);
    function close(choice) {
      try { localStorage.setItem(KEY, choice); } catch (e) {}
      box.classList.remove('is-on');
      setTimeout(function () { box.hidden = true; }, 500);
    }
    var acc = $('[data-cookie-accept]', box);
    var rej = $('[data-cookie-reject]', box);
    if (acc) acc.addEventListener('click', function () { close('accepted'); });
    if (rej) rej.addEventListener('click', function () { close('rejected'); });
  }

  /* ---------- páginas legales: dar formato profesional ---------- */
  function enhanceLegal() {
    var rtes = $$('.shopify-policy__body .rte');
    if (!rtes.length) return;
    rtes.forEach(function (rte) {
      var kids = Array.prototype.slice.call(rte.children);
      // Solo reconstruimos si el contenido es 100% párrafos (caso Shopify por defecto).
      if (!kids.length || !kids.every(function (k) { return k.tagName === 'P'; })) return;

      var frag = document.createDocumentFragment();
      var pending = [];
      function flushBody() {
        var j = 0;
        while (j < pending.length) {
          if (/^\s*[-•]\s+/.test(pending[j].replace(/<[^>]+>/g, ''))) {
            var ul = document.createElement('ul');
            while (j < pending.length && /^\s*[-•]\s+/.test(pending[j].replace(/<[^>]+>/g, ''))) {
              var li = document.createElement('li');
              li.innerHTML = pending[j].replace(/^\s*[-•]\s+/, '');
              ul.appendChild(li); j++;
            }
            frag.appendChild(ul);
          } else {
            var bp = document.createElement('p');
            bp.innerHTML = pending[j]; frag.appendChild(bp); j++;
          }
        }
        pending = [];
      }

      kids.forEach(function (p, idx) {
        var lines = p.innerHTML.split(/<br\s*\/?>/i).map(function (s) { return s.trim(); }).filter(function (s) { return s.length; });
        lines.forEach(function (line, li2) {
          var plain = line.replace(/<[^>]+>/g, '').replace(/&amp;/g, '&').trim();
          var isHead = /^\d+\.\s+\S/.test(plain) && plain.length < 90 && plain === plain.toUpperCase();
          var isLead = idx === 0 && li2 === 0 && plain.length < 90 && plain === plain.toUpperCase() && !/^\d/.test(plain);
          if (isHead) {
            flushBody();
            var h = document.createElement('p'); h.className = 'pf-legal-h'; h.textContent = plain; frag.appendChild(h);
          } else if (isLead) {
            flushBody();
            var l = document.createElement('p'); l.className = 'pf-legal-lead'; l.textContent = plain; frag.appendChild(l);
          } else {
            pending.push(line);
          }
        });
      });
      flushBody();
      rte.innerHTML = '';
      rte.appendChild(frag);
    });
  }

  /* ==========================================================================
     FILTROS DE COLECCIÓN (categoría, talla, color, precio) + orden
     Construye los filtros leyendo los datos de cada tarjeta y filtra en vivo.
     ========================================================================== */
  function initCollectionFilters() {
    var root = $('[data-collection]');
    if (!root) return;
    var grid = $('[data-grid]', root);
    var groupsEl = $('[data-filter-groups]', root);
    if (!grid || !groupsEl) return;
    var cards = $$('.pf-card', grid);
    if (!cards.length) return;

    // Colores que sabemos reconocer en el título/etiquetas del producto
    var COLORS = [
      { name: 'Negro', hex: '#111', re: /negr/i },
      { name: 'Blanco', hex: '#f2f2f2', re: /blanc/i },
      { name: 'Rojo', hex: '#d21f27', re: /\broj/i },
      { name: 'Azul', hex: '#2b5cc7', re: /azul/i },
      { name: 'Verde', hex: '#2e9e5b', re: /verde/i },
      { name: 'Amarillo', hex: '#e8c33a', re: /amarill/i },
      { name: 'Gris', hex: '#8a8a90', re: /\bgris/i },
      { name: 'Rosa', hex: '#e06a9c', re: /rosa|rosad/i },
      { name: 'Morado', hex: '#7b3fb0', re: /morad|p[uú]rpura|purple/i },
      { name: 'Naranja', hex: '#e8823a', re: /naranj/i },
      { name: 'Beige', hex: '#d9c8a9', re: /beige|crema|hueso/i },
      { name: 'Café', hex: '#6b4a2b', re: /caf[eé]|marr[oó]n/i },
      { name: 'Vinotinto', hex: '#6d1a2a', re: /vinotinto|vino tinto/i },
      { name: 'Celeste', hex: '#5fb0e0', re: /celeste/i }
    ];
    var SIZE_RE = /^(xxs|xs|s|m|l|xl|xxl|xxxl)$/i;
    var RANGES = [
      { label: 'Menos de $60.000', min: 0, max: 5999999 },
      { label: '$60.000 – $90.000', min: 6000000, max: 8999999 },
      { label: '$90.000 – $150.000', min: 9000000, max: 14999999 },
      { label: 'Más de $150.000', min: 15000000, max: Infinity }
    ];

    // Analizar cada tarjeta y recolectar valores disponibles
    var catSet = {}, colorSet = {}, sizeSet = {};
    cards.forEach(function (card) {
      var type = (card.getAttribute('data-type') || '').trim();
      var title = card.getAttribute('data-title') || '';
      var tags = (card.getAttribute('data-tags') || '').split('|').map(function (t) { return t.trim(); }).filter(Boolean);
      var hay = title + ' ' + tags.join(' ');
      var colors = COLORS.filter(function (c) { return c.re.test(hay); }).map(function (c) { return c.name; });
      var sizes = [];
      tags.forEach(function (t) {
        var m = t.match(/^talla\s*:?\s*(.+)$/i);
        if (m) sizes.push(m[1].trim().toUpperCase());
        else if (SIZE_RE.test(t)) sizes.push(t.toUpperCase());
      });
      card._pf = { type: type, price: parseInt(card.getAttribute('data-price'), 10) || 0, colors: colors, sizes: sizes };
      if (type) catSet[type] = true;
      colors.forEach(function (c) { colorSet[c] = true; });
      sizes.forEach(function (s) { sizeSet[s] = true; });
    });

    function chip(group, value, inner) {
      return '<label class="pf-fchip"><input type="checkbox" data-fgroup="' + group + '" value="' +
        String(value).replace(/"/g, '&quot;') + '"><span>' + inner + '</span></label>';
    }
    // Solo mostramos los rangos de precio que tengan productos
    var usableRanges = RANGES.filter(function (r) {
      return cards.some(function (c) { return c._pf.price >= r.min && c._pf.price <= r.max; });
    });

    var html = '';
    var cats = Object.keys(catSet).sort();
    if (cats.length > 1) {
      html += '<div class="pf-fgroup"><div class="pf-fgroup__title">Categoría</div><div class="pf-fopts">';
      cats.forEach(function (c) { html += chip('type', c, c); });
      html += '</div></div>';
    }
    var sizes = Object.keys(sizeSet).sort();
    if (sizes.length) {
      html += '<div class="pf-fgroup"><div class="pf-fgroup__title">Talla</div><div class="pf-fopts">';
      sizes.forEach(function (s) { html += chip('size', s, s); });
      html += '</div></div>';
    }
    var colors = Object.keys(colorSet).sort();
    if (colors.length > 1) {
      html += '<div class="pf-fgroup"><div class="pf-fgroup__title">Color</div><div class="pf-fopts">';
      colors.forEach(function (c) {
        var def = COLORS.filter(function (x) { return x.name === c; })[0];
        var sw = def ? '<span class="pf-fswatch" style="background:' + def.hex + '"></span>' : '';
        html += chip('color', c, sw + c);
      });
      html += '</div></div>';
    }
    if (usableRanges.length > 1) {
      html += '<div class="pf-fgroup"><div class="pf-fgroup__title">Precio</div><div class="pf-fopts">';
      usableRanges.forEach(function (r, i) { html += chip('price', i, r.label); });
      html += '</div></div>';
    }
    groupsEl.innerHTML = html;

    var countEl = $('[data-result-count]', root);
    var noRes = $('[data-noresults]', root);
    function selected(group) {
      return $$('input[data-fgroup="' + group + '"]:checked', groupsEl).map(function (i) { return i.value; });
    }
    function apply() {
      var selCat = selected('type'), selSize = selected('size'), selColor = selected('color'), selPrice = selected('price');
      var visible = 0;
      cards.forEach(function (card) {
        var d = card._pf, ok = true;
        if (selCat.length && selCat.indexOf(d.type) === -1) ok = false;
        if (ok && selSize.length && !d.sizes.some(function (s) { return selSize.indexOf(s) > -1; })) ok = false;
        if (ok && selColor.length && !d.colors.some(function (c) { return selColor.indexOf(c) > -1; })) ok = false;
        if (ok && selPrice.length && !selPrice.some(function (idx) { var r = usableRanges[+idx]; return r && d.price >= r.min && d.price <= r.max; })) ok = false;
        card.style.display = ok ? '' : 'none';
        if (ok) visible++;
      });
      if (countEl) countEl.textContent = visible;
      if (noRes) noRes.hidden = visible !== 0;
    }
    groupsEl.addEventListener('change', apply);

    $$('[data-filter-clear]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('input[type=checkbox]', groupsEl).forEach(function (i) { i.checked = false; });
        apply();
      });
    });

    var sortSel = $('[data-sort]', root);
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        var val = sortSel.value, arr = cards.slice();
        if (val === 'price-asc') arr.sort(function (a, b) { return a._pf.price - b._pf.price; });
        else if (val === 'price-desc') arr.sort(function (a, b) { return b._pf.price - a._pf.price; });
        else if (val === 'title-asc') arr.sort(function (a, b) { return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || ''); });
        arr.forEach(function (c) { grid.appendChild(c); });
      });
    }

    // Panel móvil (offcanvas)
    var panel = $('[data-filters]', root), overlay = $('.pf-filters-overlay', root);
    function openF() { if (panel) panel.classList.add('is-open'); if (overlay) { overlay.hidden = false; overlay.classList.add('is-open'); } document.body.style.overflow = 'hidden'; }
    function closeF() { if (panel) panel.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
    $$('[data-filter-open]', root).forEach(function (b) { b.addEventListener('click', openF); });
    $$('[data-filter-close]', root).forEach(function (b) { b.addEventListener('click', closeF); });
    $$('[data-filter-apply]', root).forEach(function (b) { b.addEventListener('click', closeF); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeF(); });
  }

  /* ---------- carruseles aleatorios (p. ej. "También te puede gustar") ---------- */
  function initShuffle() {
    $$('[data-shuffle]').forEach(function (track) {
      var cards = Array.prototype.slice.call(track.children);
      if (cards.length < 2) return;
      // Barajado Fisher-Yates
      for (var i = cards.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = cards[i]; cards[i] = cards[j]; cards[j] = tmp;
      }
      var limit = parseInt(track.getAttribute('data-shuffle-limit'), 10) || cards.length;
      cards.forEach(function (c, idx) {
        if (idx >= limit) { c.remove(); }       // sobran: fuera del carrusel
        else { track.appendChild(c); }          // reordena en el nuevo orden
      });
    });
  }

  /* ---------- init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initShuffle();
    enhanceLegal();
    initHeroRotate();
    initCookie();
    initCollectionFilters();
    initReveals();
    initHeader();
    initMarquee();
    initCarousels();
    initGallery();
    initQtyInputs();
    initCart();
    initAddForms();
    initVariants();
    getCart().then(function (c) { updateCartCount(c.item_count); }).catch(function () {});
  });
  window.addEventListener('load', initMarquee);
  window.addEventListener('resize', function () { clearTimeout(window.__pfrz); window.__pfrz = setTimeout(initMarquee, 200); });
})();
